var nurseslounge_lounge_ratingReviews = {
    init:function($params, cback){
        $params = $.extend({},$params, {tab:'init'});
        nurseslounge_lounge_overview.information_lounge_get('init', $params, function($data){
            nurseslounge_lounge_ratingReviews.information_administrator_edit($params, $data);
        });
        $params = $.extend({},$params, {
            user_id:libs.memoryGet('user_id'),
            tab:'review_init'
        });
        nurseslounge_lounge_ratingReviews.reviews_get($params, function($data){
            if(
                $data.data.lounge.lounge_type_id == 1 || //employer
                $data.data.lounge.lounge_type_id == 2 //school
            ) {
                nurseslounge_lounge_ratingReviews.reviews_rating($params, $data);
            }else{
                router.navigate('/lounges');
            }
            if(cback != undefined){
                cback();
            }
        });
        nurseslounge_lounge_ratingReviews.banners_location(function($config){
            nurseslounge_myDashboard_myProfile.banners_engine($config);
        });
        nurseslounge_lounge_ratingReviews.task_list_container(function($container){
            $params = $.extend({}, $params, {only:'owners'});
            nurseslounge_myDashboard_myProfile.task_list($container, $params);
        });
        nurseslounge_lounge_ratingReviews.report_container(function($container){
            nurseslounge_lounge_overview.report($container, $params);
        });
        nurseslounge_lounge_ratingReviews.lounge_ads_location(function($config){
            nurseslounge_lounge_overview.lounge_ads_engine($config);
        });
    },
    //Administrator
    information_administrator_edit:function($params, $data){
        var $modal = $("#nurseslounge-lounge-information-edit-modal");
        var $isEmployer = $data && $data.data && $data.data.lounge && $data.data.lounge.lounge_type_id ? $data.data.lounge.lounge_type_id == 1 : false;
        var $isSchool = $data && $data.data && $data.data.lounge && $data.data.lounge.lounge_type_id ? $data.data.lounge.lounge_type_id == 2 : false;
        var $isSpecialty = $data && $data.data && $data.data.lounge && $data.data.lounge.lounge_type_id ? $data.data.lounge.lounge_type_id == 8 : false;
        var $thoughtLeaders = $data && $data.data && $data.data.lounge && $data.data.lounge.lounge_type_id ? $data.data.lounge.lounge_type_id == 9 : false;
        var $credential = $data && $data.data && $data.data.user_credential ? $data.data.user_credential : [];
        $isEmployer = !$isEmployer ? $params.typeName == 'employers' : $isEmployer;
        $isSchool = !$isSchool ? $params.typeName == 'schools' : $isSchool;
        $isSpecialty = !$isSpecialty ? $params.typeName == 'specialties' : $isSpecialty;
        $thoughtLeaders = !$thoughtLeaders ? $params.typeName == 'thoughtLeaders' : $thoughtLeaders;
        $credential = $credential.map(function($x){return parseInt($x);});
        var $createNewLoungeAccess = $.inArray(5, $credential) != -1 ? true : false;
        var $editNewLoungeAccess = $.inArray(6, $credential) != -1   ? true : false;
        var $deleteNewLoungeAccess = $.inArray(15, $credential) != -1  ? true : false;
        var $helpVideos = $.inArray(37, $credential) != -1  ? true : false;
        var $allowTabs = {
            'information': $.inArray(7, $credential) != -1 ? true : false,
            'otherNames': $.inArray(62, $credential) != -1 && !$thoughtLeaders ? true : false,
            'specialties': $.inArray(80, $credential) != -1 && $isSpecialty || $.inArray(80, $credential) != -1 && $thoughtLeaders ? true : false,
            'location':    $.inArray(8, $credential) != -1 && !$thoughtLeaders ? true : false,
            'multimedia':  $.inArray(9, $credential) != -1 ? true : false,
            'virtualTour':  $.inArray(83, $credential) != -1 && !$thoughtLeaders ? true : false,
            'recruiters':  $.inArray(10, $credential) != -1 && !$thoughtLeaders ? true : false,
            'owners':  $.inArray(11, $credential) != -1 ? true : false,
            'jobs':  $.inArray(12, $credential) != -1 && $isEmployer || $.inArray(12, $credential) != -1 && $isSchool ? true : false,
            'import':  $.inArray(13, $credential) != -1 && $isEmployer || $.inArray(13, $credential) != -1 && $isSchool ? true : false,
            'api':  $.inArray(13, $credential) != -1 && $isEmployer || $.inArray(13, $credential) != -1 && $isSchool ? true : false,
            'statistics':  $.inArray(14, $credential) != -1 ? true : false,
            'degrees':  $.inArray(17, $credential) != -1 && $isSchool ? true : false,
            'invite':  $.inArray(24, $credential) != -1 ? true : false,
            'inviteStatistics':  $.inArray(28, $credential) != -1 ? true : false,
            'inviteTemplates':  $.inArray(66, $credential) != -1 ? true : false,
            'createLogo':  $.inArray(67, $credential) != -1 ? true : false,
            'buyAds':  $.inArray(71, $credential) != -1 && $isSchool ? true : false,
            'sponsorDegrees':  $.inArray(75, $credential) != -1 && $isSchool ? true : false,
            'spotlightJobs':  $.inArray(77, $credential) != -1 && !$isSchool && !$thoughtLeaders ? true : false,
        };
        var $allowTabsFiltered = $allowTabs;
        $allowTabs = {};
        $.each($allowTabsFiltered, function($k, $v) {var $newObj = {};$newObj[$k]=$v;if($v){$.extend($allowTabs, $newObj);}});
        var $information = $("#nurseslounge-lounge-reviews");
        var $informationRight = $information.find('.nurseslounge-lounge-reviews-right:first .administrator:first');
        var $options = $informationRight.find('.option');
        $options.each(function(){
            var $that = $(this);
            var $action = $that.data('action');
            if(
                $createNewLoungeAccess && $action == 'create' ||
                $editNewLoungeAccess && $action == 'edit' ||
                $deleteNewLoungeAccess && $action == 'delete' ||
                $helpVideos && $action == 'help-videos' ||
                $helpVideos && $action == 'create-pin-it' ||
                $helpVideos && $action == 'create-event' ||
                $helpVideos && $action == 'send-invitation' ||
                $helpVideos && $action == 'examples-posts'
            ) {
                $that.unbind().click(function () {
                    var $tab = null;
                    $.each($allowTabs, function($i, $v){
                        if($v){
                            $tab = $i;
                            return false;
                        }
                    });
                    if(
                        $tab && $action == 'create' ||
                        $tab && $action == 'edit'
                    ){
                        nurseslounge_lounge_overview.information_administrator_select_tab($action, $tab, $allowTabs, $params, function () {
                            $modal.scrollTop(0);
                            $modal.modal('show');
                        });
                    }else
                    if($tab && $action == 'help-videos'){
                        window.open('https://www.home.nurseslounge.com/help-center', '_blank', '');
                    }else
                    if($tab && $action == 'create-pin-it'){
                        nurseslounge_lounge_overview.information_administrator_tab_open_video('https://www.youtube.com/watch?v=NedHuxskMV8');
                    }else
                    if($tab && $action == 'create-event'){
                        nurseslounge_lounge_overview.information_administrator_tab_open_video('https://www.youtube.com/watch?v=Dd4XKeHIAo0');
                    }else
                    if($tab && $action == 'send-invitation'){
                        nurseslounge_lounge_overview.information_administrator_tab_open_video('https://www.youtube.com/watch?v=FbQw8gA_KmU');
                    }else
                    if($tab && $action == 'examples-posts'){
                        nurseslounge_lounge_overview.information_administrator_tab_open_images();
                    }else
                    if($action == 'delete'){
                        if(confirm('Are you sure you want to delete this lounge?')){
                            $params = $.extend({},$params, {action:$action,tab:$action});
                            nurseslounge_lounge_overview.information_administrator_tab_request($params, function($data){
                                if($data.status == 'success'){
                                    router.navigate('/lounges');
                                }
                            });
                        }
                    }
                });
            }
        });
        if($isEmployer){
            $modal.find('.nav-pills .nav-link[data-target="#otherNames"]').html("Facility Names");
        }else{
            $modal.find('.nav-pills .nav-link[data-target="#otherNames"]').html("Other Names");
        }
    },
    reviews_get:function($params, cback){//tabs reviews
        $.ajax({
            url: "/lounge/reviews/get",
            method: "POST",
            cache:false,
            dataType: "json",
            data:$params,
            success: function ($data) {
                libs.expire($data);
                if($data.status == 'error'){
                    $("#nurseslounge-lounge-information-review-modal").modal('hide');
                    $("#nurseslounge-lounge-review-answer-modal").modal('hide');
                }
                cback($data);
            }
        });
    },
    reviews_rating:function($params, $data){
        var $typeId = $data.data.lounge.lounge_type_id ? $data.data.lounge.lounge_type_id : 0;
        var $nursesloungeLoungeReview = $("#nurseslounge-lounge-reviews");
        var $reviewModal = $("#nurseslounge-lounge-information-review-modal");
        var $loungeReviewsRight = $nursesloungeLoungeReview.find('.nurseslounge-lounge-reviews-right:first');
        var $ratingFirst = $loungeReviewsRight.find('.rating-stars:first');
        var $ratingCount = $loungeReviewsRight.find('.rating-count:first');
        var $addReviewFirst = $loungeReviewsRight.find('.add-review:first');
        var $deleteReviewFirst = $loungeReviewsRight.find('.delete-review:first');
        $ratingFirst.unbind().click(function(){
            nurseslounge_lounge_overview.information_review($typeId, $params, $data, function(){
                libs.refreshBoxFrom('.review-box', $params, function(){
                    nurseslounge_lounge_ratingReviews.init($params);
                    $reviewModal.modal('hide');
                });
            });
        });
        $ratingCount.unbind().click(function(){
            nurseslounge_lounge_overview.information_review($typeId, $params, $data, function(){
                libs.refreshBoxFrom('.review-box', $params, function(){
                    nurseslounge_lounge_ratingReviews.init($params);
                    $reviewModal.modal('hide');
                });
            });
        });
        $addReviewFirst.unbind().click(function(){
            nurseslounge_lounge_overview.information_review($typeId, $params, $data, function(){
                libs.refreshBoxFrom('.review-box', $params, function(){
                    nurseslounge_lounge_ratingReviews.init($params);
                    $reviewModal.modal('hide');
                });
            });
        });
        $deleteReviewFirst.unbind().click(function(){
            if(confirm('Are you sure you want to delete your review?')){
                nurseslounge_lounge_overview.information_remove_review($params, function(){
                    libs.refreshBoxFrom('.review-box', $params, function(){
                        nurseslounge_lounge_ratingReviews.init($params);
                        $reviewModal.modal('hide');
                    });
                });
            }
        });
        nurseslounge_lounge_ratingReviews.reviews_rating_list($params);
    },
    reviews_rating_list:function($params){
        var $loungeReviewsLeft = $("#nurseslounge-lounge-reviews .nurseslounge-lounge-reviews-left");
        var $commentsList = $loungeReviewsLeft.find(".comments-list:first");
        var $commentsListPreview = nurseslounge_lounge_ratingReviews.comments_preview();
        var $resultInfo = $loungeReviewsLeft.find(".result-info-count:first");
        var $resultPreview = '&nbsp;';
        var $paginationNav = $loungeReviewsLeft.find('.pagination-nav');
        var $paginationNavPreview = '&nbsp;';
        $resultInfo.addClass('nurseslounge-lounge-reviews-preload').html($resultPreview);
        $paginationNav.addClass('nurseslounge-lounge-reviews-preload').html($paginationNavPreview);
        $commentsList.html($commentsListPreview).promise().done(function(){
            nurseslounge_lounge_ratingReviews.reviews_rating_pagination($params);
        });
    },
    comments_preview:function(){
        var $chtml = '';
        for(var $i=1; $i<=5; $i++){
            $chtml+= '' +
                '<li class="shadow p-3 mb-3 bg-white preview rounded">' +
                '    <div class="row pb-4 border-bottom">' +
                '        <div class="col-12 align-self-center">' +
                '            <div class="row d-flex">' +
                '                <div class="col-12 col-md-4 pb-2 pb-sm-0 ">' +
                '                    <label class="text-muted font-weight-normal mb-0">' +
                '                       &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                       &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                       &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                    </label>' +
                '                    <p class="nurseslounge-lounge-reviews-preload">' +
                '                       &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                       &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                       &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                    </p>' +
                '                </div>' +
                '                <div class="col-12 col-md-auto pb-2 pb-sm-0">' +
                '                    <label class="text-muted font-weight-normal mb-0">' +
                '                       &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                       &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                       &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                    </label>' +
                '                    <p class="nurseslounge-lounge-reviews-preload">' +
                '                       &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                       &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                       &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                    </p>' +
                '                </div>' +
                '                <div class="col-12 col-md-auto pb-2 pb-sm-0">' +
                '                    <label class="text-muted font-weight-normal mb-0">' +
                '                       &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                       &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                       &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                    </label>' +
                '                    <p class="nurseslounge-lounge-reviews-preload">' +
                '                       &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                       &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                       &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                    </p>' +
                '                </div>' +
                '            </div>' +
                '        </div>' +
                '    </div>' +
                '    <div class="row mt-3">' +
                '        <div class="col-sm">' +
                '            <div class="font-weight-bold mb-2">' +
                '               Review' +
                '            </div>' +
                '        </div>' +
                '        <div class="col-sm-auto">' +
                '            <div class="clg-rating d-flex">' +
                '                <div class="rating-count align-self-center mr-2 nurseslounge-lounge-reviews-preload">' +
                '                   &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                   &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                </div>' +
                '                <div class="rating-stars align-self-center mt-n2">' +
                '                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 12.705 512 486.59" x="0px" y="0px" xml:space="preserve" width="32px" height="32px" fill="#E2E2E9"><polygon points="256.814,12.705 317.205,198.566 512.631,198.566 354.529,313.435 414.918,499.295 256.814,384.427 98.713,499.295 159.102,313.435 1,198.566 196.426,198.566 "></polygon></svg>' +
                '                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 12.705 512 486.59" x="0px" y="0px" xml:space="preserve" width="32px" height="32px" fill="#E2E2E9"><polygon points="256.814,12.705 317.205,198.566 512.631,198.566 354.529,313.435 414.918,499.295 256.814,384.427 98.713,499.295 159.102,313.435 1,198.566 196.426,198.566 "></polygon></svg>' +
                '                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 12.705 512 486.59" x="0px" y="0px" xml:space="preserve" width="32px" height="32px" fill="#E2E2E9"><polygon points="256.814,12.705 317.205,198.566 512.631,198.566 354.529,313.435 414.918,499.295 256.814,384.427 98.713,499.295 159.102,313.435 1,198.566 196.426,198.566 "></polygon></svg>' +
                '                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 12.705 512 486.59" x="0px" y="0px" xml:space="preserve" width="32px" height="32px" fill="#E2E2E9"><polygon points="256.814,12.705 317.205,198.566 512.631,198.566 354.529,313.435 414.918,499.295 256.814,384.427 98.713,499.295 159.102,313.435 1,198.566 196.426,198.566 "></polygon></svg>' +
                '                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 12.705 512 486.59" x="0px" y="0px" xml:space="preserve" width="32px" height="32px" fill="#E2E2E9"><polygon points="256.814,12.705 317.205,198.566 512.631,198.566 354.529,313.435 414.918,499.295 256.814,384.427 98.713,499.295 159.102,313.435 1,198.566 196.426,198.566 "></polygon></svg>' +
                '                </div>' +
                '            </div>' +
                '        </div>' +
                '    </div>' +
                '    <div class="row">' +
                '        <div class="col-sm-12 mb-2">' +
                '            <div class="review-desc bg-light p-4">' +
                '                <h5 class="nurseslounge-lounge-reviews-preload">&nbsp;</h5>' +
                '                <p class="nurseslounge-lounge-reviews-preload">&nbsp;</p>' +
                '            </div>' +
                '        </div>' +
                '        <div class="col-sm-12 mb-2">' +
                '            <div class="review-desc bg-light p-4">' +
                '                <h5 class="nurseslounge-lounge-reviews-preload">&nbsp;</h5>' +
                '                <p class="nurseslounge-lounge-reviews-preload">&nbsp;</p>' +
                '            </div>' +
                '        </div>' +
                '    </div>' +
                '</li>';
        }
        return $chtml;
    },
    reviews_rating_pagination:function($params){
        var $reload;
        var $loaded = false;
        var $afterFirstPagination = false;
        var $loungeReviewsLeft = $("#nurseslounge-lounge-reviews .nurseslounge-lounge-reviews-left");
        var $commentsList = $loungeReviewsLeft.find('.comments-list:first');
        var $paginationNav = $loungeReviewsLeft.find('.pagination-nav:first');
        var $previewHeight = $loungeReviewsLeft.find('.comments-list .preview:first').innerHeight();
        var $commentsHeight = $commentsList.innerHeight();
        var $pageSize = Math.round(($commentsHeight/$previewHeight));
        var $resultInfo = $loungeReviewsLeft.find(".result-info-count:first");
        var $saveParams = $params;
        var $paginationObj;
        var $userCredential;
        var $isOwner;
        try{
            $paginationObj = libs.memoryGet('reviews_rating_pagination');
            if($paginationObj){
                $paginationObj.pagination('destroy');
            }
        }catch ($e) {
        }
        $paginationObj = $paginationNav.pagination({
            pageSize: $pageSize,
            showPageNumbers: true,
            showPrevious: true,
            showNext: true,
            showNavigator: true,
            showFirstOnEllipsisShow: true,
            showLastOnEllipsisShow: true,
            dataSource:window.location.protocol +'//'+ window.location.hostname + "/lounge/reviews/get",
            locator: 'data.reviews',
            ajax:{
                method: "POST",
                cache:false,
                dataType: "json",
                data:$.extend({}, $params, {tab:'reviews_list'}),
                beforeSend: function() {
                    $commentsList.html(nurseslounge_lounge_ratingReviews.comments_preview());
                },
                complete:function($data){
                    libs.expire($data.responseJSON);
                    if($data.responseJSON.status == 'error'){
                        $("#nurseslounge-lounge-information-review-modal").modal('hide');
                        $("#nurseslounge-lounge-review-answer-modal").modal('hide');
                    }
                }
            },
            totalNumberLocator: function($data) {
                $userCredential = $data.data.user_credential.map(function($x){return parseInt($x);});
                $isOwner = $data.data.is_owner;
                return $data.data.total;
            },
            callback: function($data, $pagination) {
                $loaded = true;
                if($commentsList.length > 0 && $commentsList.offset().top > 0 && $afterFirstPagination){
                    $('html, body').animate({scrollTop:$commentsList.offset().top - 100});
                }else{
                    $afterFirstPagination = true;
                }
                var $pageNumber = $pagination.pageNumber;
                var $pageSize = $pagination.pageSize;
                var $totalNumber = $pagination.totalNumber;
                var $first = $totalNumber > 0 ? (($pageNumber-1) * $pageSize) + 1 : 0;
                var $last = $totalNumber > 0 ? ($first + $data.length - 1) : 0;
                $paginationNav.removeClass('nurseslounge-lounge-reviews-preload');
                $resultInfo.removeClass('nurseslounge-lounge-reviews-preload').html('<strong>Showing '+$first+' - '+$last+' of '+$totalNumber+'</strong> results for <span class="link-color">Reviews</span>');
                var $chtml = nurseslounge_lounge_ratingReviews.item_html($data, $userCredential, $isOwner);
                libs.checkImageLoad($($chtml).find('img'), function () {
                    $commentsList.html('').html($chtml).promise().done(function () {
                        nurseslounge_lounge_ratingReviews.list_events($saveParams);
                    });
                });
            }
        });
        libs.memorySave('reviews_rating_pagination', $paginationObj);
        $reload = setTimeout(function(){
            if(!$loaded){
                nurseslounge_lounge_ratingReviews.reviews_rating_pagination($params);
            }else{
                clearTimeout($reload);
            }
        }, 10000);
    },
    item_html:function($reviews, $userCredential, $isOwner){
        var $userId = libs.memoryGet('user_id');
        var $chtml = '';
        $.each($reviews, function($i, $v){
            $chtml+='' +
                '<li class="shadow p-3 mb-3 bg-white rounded" data-key="'+$v.key+'">' +
                '    <div class="row pb-4 border-bottom">' +
                '        <div class="col-12 align-self-center">' +
                '            <div class="row d-flex">';
            if($userCredential && $.inArray(16, $userCredential) != -1 || $isOwner) {
                $chtml+='' +
                    '<div class="col-12">' +
                    '    <img src="/bimg/NursesLounge/more-horizontal-back.png" alt="horizontal dots" class="pull-right answer-review">' +
                    '</div>';
            }
            if($v.type == 'employer') {
                $chtml += '' +
                    '<div class="col-12 col-md-4 pb-2 pb-sm-0 ">' +
                    '    <label class="text-muted font-weight-normal mb-0">' +
                    '       Job Title' +
                    '    </label>' +
                    '    <p>' + $v.job_title + '</p>' +
                    '</div>' +
                    '<div class="col-12 col-md-4 pb-2 pb-sm-0">' +
                    '    <label class="text-muted font-weight-normal mb-0">' +
                    '       Facility' +
                    '    </label>' +
                    '    <p>' + $v.facility + '</p>' +
                    '</div>' +
                    '<div class="col-12 col-md-4 pb-2 pb-sm-0">';
                if($v.recommend_to_friend == 'yes'){
                    $chtml+='' +
                        '<div class="row">' +
                        '   <div class="col-8 offset-4 mt-3">' +
                        '       <img src="/bimg/NursesLounge/recommended-button.png" class="img-fluid">' +
                        '   </div>' +
                        '</div>';
                }
                $chtml += '' +
                    '</div>';
            }
            if($v.type == 'school'){
                if($v.current_profile_id != 5){
                    $chtml += '' +
                        '<div class="col-12 col-md-4 pb-2 pb-sm-0 ">' +
                        '    <label class="text-muted font-weight-normal mb-0">' +
                        '       School Degree' +
                        '    </label>' +
                        '    <p>' + $v.school_degree + '</p>' +
                        '</div>';
                }else{
                    $chtml += '' +
                        '<div class="col-12 col-md-4 pb-2 pb-sm-0 "></div>';
                }
                $chtml += '' +
                    '<div class="col-12 col-md-4 offset-md-4 pb-2 pb-sm-0">';
                if($v.recommend_to_friend == 'yes'){
                    $chtml+='' +
                        '<div class="row">' +
                        '   <div class="col-8 offset-4 mt-3">' +
                        '       <img src="/bimg/NursesLounge/recommended-button.png" class="img-fluid">' +
                        '   </div>' +
                        '</div>';
                }
                $chtml += '' +
                    '</div>';
            }
            $chtml+='' +
                '            </div>' +
                '        </div>' +
                '    </div>' +
                '    <div class="row mt-3">' +
                '        <div class="col-sm">';
            if($v.current_profile_id == 5){
                $chtml+='<div class="font-weight-bold mb-2">Nurse Faculty Job Rating</div>';
            }
            $chtml+='' +
                '            <div class="font-weight-bold mb-2">';
            if($v.pros_cons && $v.pros_cons != '') {
            $chtml+='' +
                '               Review';
            }
            $chtml+='' +
                '            </div>' +
                '        </div>' +
                '        <div class="col-sm-auto">' +
                '            <div class="clg-rating d-flex">' +
                '                <div class="rating-count align-self-center mr-2 ">' +
                $v.overall_rating + ' / 5' +
                '                </div>' +
                '                <div class="rating-stars align-self-center mt-n2">' +
                nurseslounge_lounge_ratingReviews.add_stars($v.overall_rating) +
                '                </div>' +
                '            </div>' +
                '        </div>' +
                '    </div>' +
                '    <div class="row">';
            if($v.pros_cons && $v.pros_cons != '') {
                $chtml += '' +
                    '        <div class="col-sm-12 mb-2">' +
                    '            <div class="pros review-desc bg-light p-4">' +
                    '                <p>' + $v.pros_cons + '</p>' +
                    '            </div>' +
                    '        </div>';
            }
            $chtml+='' +
                '    </div>';
            if($v.user.id == $userId){
                //Rating And Reviews
                $chtml+='' +
                    '<div class="row">' +
                    '   <div class="col-6 text-center">' +
                    '       <h6>' +
                    '           <a href="javascript:void(0)" class="stretched-link link-color delete-review" data-lounge_key="'+$v.lounge.key+'">' +
                    '               Delete my Review' +
                    '           </a>' +
                    '       </h6>' +
                    '   </div>' +
                    '   <div class="col-6 text-center">' +
                    '       <h6>' +
                    '           <a href="javascript:void(0)" class="stretched-link link-color add-review" data-lounge_key="'+$v.lounge.key+'">' +
                    '               Edit My Review' +
                    '           </a>' +
                    '       </h6>' +
                    '   </div>' +
                    '</div>';
            }
            if($v.answer) {
                $chtml += '' +
                    '<div class="row border-top mt-3">' +
                    '  <div class="col-sm-12">' +
                    '  Response:' +
                    //'    <div class="result-info-count pt-3">Response from ' +
                    //'       <span class="link-color font-weight-bold open-url" data-url="'+$v.answer.user.profile_url+'">' +
                    //$v.answer.user.long_name +
                    //'       </span>' +
                    //'    </div>' +
                    '    <div class="contact-header link-color font-weight-normal">' +
                    '      <p>' +
                    $v.answer.answer +
                    '      </p>' +
                    '    </div>' +
                    '  </div>' +
                    '</div>';
            }
            $chtml += '' +
                '</li>';
        });
        return $chtml;
    },
    add_stars:function($rating){
        var $chtml = '';
        for(var $i=1; $i<=5; $i++) {
            var $star = $rating - $i;
            var $offsetOn;
            var $offsetOff;
            var $unique = libs.getUniqueId();
            if($star >= 0){
                $offsetOn = 100;
                $offsetOff = 0;
            }else if($star < 0 && $star > -1){
                $star = ($star * -1);
                $offsetOff = ($star * 100);
                $offsetOn = (100 - $offsetOff);
            }else{
                $offsetOn = 0;
                $offsetOff = 100;
            }
            $chtml += '' +
                '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 12.705 512 486.59" x="0px" y="0px" xml:space="preserve" width="32px" height="32px" fill="url(#percent'+$unique+')">' +
                '   <defs>' +
                '       <linearGradient id="percent'+$unique+'">';
            if($offsetOn > 0) {
                $chtml += '' +
                    '<stop offset="' + $offsetOn + '%" stop-color="#FDA630" stop-opacity="1"></stop>';
            }
            if($offsetOff > 0){
                $chtml += '' +
                    '<stop offset="'+$offsetOff+'%" stop-color="#E2E2E9" stop-opacity="1"></stop>';
            }
            $chtml += '' +
                '       </linearGradient>' +
                '   </defs>' +
                '   <polygon points="256.814,12.705 317.205,198.566 512.631,198.566 354.529,313.435 414.918,499.295 256.814,384.427 98.713,499.295 159.102,313.435 1,198.566 196.426,198.566"></polygon>' +
                '</svg>';
        }
        return $chtml;
    },
    list_events:function($params){
        var $reviewModal = $("#nurseslounge-lounge-information-review-modal");
        var $loungeReviewsLeft = $("#nurseslounge-lounge-reviews .nurseslounge-lounge-reviews-left");
        var $commentsList = $loungeReviewsLeft.find('.comments-list:first');
        $commentsList.find('.answer-review').unbind().click(function(){
            var $key = $(this).parents('li:first').data('key');
            nurseslounge_lounge_ratingReviews.reviews_edit_review($params, $key);
        });
        $commentsList.find('.open-url').unbind().click(function(){
            var $url = $(this).data('url');
            window.open($url,'_blank');
        });
        $commentsList.find('.add-review').unbind().click(function(){
            var $that = $(this);
            var $key = $that.data('lounge_key');
            $params = $.extend({}, $params, {key:$key});
            nurseslounge_myDashboard_myProfile.lounge_review_get_request($params, function($data){
                var $typeId = $data.data.lounge.lounge_type_id;
                nurseslounge_lounge_overview.information_review($typeId, $params, $data, function(){
                    libs.refreshBoxFrom('.review-box', $params, function(){
                        nurseslounge_lounge_ratingReviews.init($params);
                        $reviewModal.modal('hide');
                    });
                });
            });
        });
        $commentsList.find('.delete-review').unbind().click(function(){
            var $that = $(this);
            var $key = $that.data('lounge_key');
            $params = $.extend({}, $params, {key:$key});
            if(confirm('Are you sure you want to delete your review?')){
                nurseslounge_lounge_overview.information_remove_review($params, function(){
                    libs.refreshBoxFrom('.review-box', $params, function(){
                        nurseslounge_lounge_ratingReviews.init($params);
                        $reviewModal.modal('hide');
                    });
                });
            }
        });
    },
    reviews_edit_review:function($params, $reviewKey){
        $params = $.extend({},$params,{
            user_id:libs.memoryGet('user_id'),
            review_key:$reviewKey,
            tab:'review'
        });
        var $modal = $("#nurseslounge-lounge-review-answer-modal");
        var $modalInfo = $modal.find('.modal-info');
        nurseslounge_lounge_ratingReviews.reviews_get($params, function($data){
            var $modalInfoContent = nurseslounge_lounge_ratingReviews.item_popup_html($data);
            $modalInfo.html($modalInfoContent).promise().done(function () {
                nurseslounge_lounge_ratingReviews.reviews_popup_events($params, $data, function () {
                    $modal.modal('show');
                });
            });
        });
    },
    item_popup_html:function($data){
        var $review = $data.data.review;
        var $chtml = '';
        $chtml+='' +
            '<div class="row">' +
            '    <div class="col-sm-6">' +
            //'        <div>' +
            //'            Written by' +
            //'            <span class="link-color font-weight-bold open-url" data-url="'+$review.user.profile_url+'">'+$review.user.long_name+'</span>' +
            //'        </div>' +
            '    </div>' +
            '    <div class="col-sm-6 text-sm-right">' +
            '        <div class="text-muted">'+$review.date+'</div>' +
            '    </div>' +
            '    <div class="col-sm-12">' +
            '        <div class="pt-4 mb-3 bg-white rounded">' +
            '            <div class="row pb-2">' +
            '                <div class="col-12 align-self-center">' +
            '                    <div class="row d-flex">';
        if($review.type == 'employer') {
            $chtml += '' +
                '<div class="col-12 col-md-4 pb-2 pb-sm-0 ">' +
                '    <label class="text-muted font-weight-normal mb-0">' +
                '       Job Title' +
                '    </label>' +
                '    <p>' + $review.job_title + '</p>' +
                '</div>' +
                '<div class="col-12 col-md-4 pb-2 pb-sm-0">' +
                '    <label class="text-muted font-weight-normal mb-0">' +
                '       Facility' +
                '    </label>' +
                '    <p>' + $review.facility + '</p>' +
                '</div>' +
                '<div class="col-12 col-md-4 pb-2 pb-sm-0">';
            if($review.recommend_to_friend == 'yes'){
                $chtml+='' +
                    '<div class="row">' +
                    '   <div class="col-8 offset-4 mt-3">' +
                    '       <img src="/bimg/NursesLounge/recommended-button.png" class="img-fluid">' +
                    '   </div>' +
                    '</div>';
            }
            $chtml += '' +
                '</div>';
        }
        if($review.type == 'school'){
            if($review.current_profile_id != 5){
                $chtml += '' +
                    '<div class="col-12 col-md-4 offset-md-4 pb-2 pb-sm-0 ">' +
                    '    <label class="text-muted font-weight-normal mb-0">' +
                    '       School Degree' +
                    '    </label>' +
                    '    <p>' + $review.school_degree + '</p>' +
                    '</div>';
            }else{
                $chtml += '' +
                    '<div class="col-12 col-md-4 offset-md-4 pb-2 pb-sm-0 "></div>';
            }
            $chtml += '' +
                '<div class="col-12 col-md-4 pb-2 pb-sm-0">';
            if($review.recommend_to_friend == 'yes'){
                $chtml+='' +
                    '<div class="row">' +
                    '   <div class="col-8 offset-4 offset-md-4 mt-3">' +
                    '       <img src="/bimg/NursesLounge/recommended-button.png" class="img-fluid">' +
                    '   </div>' +
                    '</div>';
            }
            $chtml += '' +
                '</div>';

        }
        $chtml+='' +
            '                    </div>' +
            '                </div>' +
            '            </div>' +
            '            <div class="row mt-2">' +
            '                <div class="col-sm">' +
            '                    <div class="font-weight-bold mb-2">';
        if($review.pros_cons && $review.pros_cons != '') {
            $chtml += '' +
                '                       Review';
        }
        $chtml += '' +
            '                    </div>' +
            '                </div>' +
            '                <div class="col-sm-auto">' +
            '                    <div class="clg-rating d-flex">' +
            '                        <div class="rating-count align-self-center mr-2">' +
            $review.overall_rating + ' / 5' +
            '                        </div>' +
            '                        <div class="rating-stars align-self-center mt-n2">' +
            nurseslounge_lounge_ratingReviews.add_stars($review.overall_rating) +
            '                        </div>' +
            '                    </div>' +
            '                </div>' +
            '            </div>' +
            '            <div class="row">';
        if($review.pros_cons && $review.pros_cons != '') {
            $chtml += '' +
                '                <div class="col-sm-12 mb-2">' +
                '                    <div class="review-desc bg-light p-4">' +
                '                        <p>' + $review.pros_cons + '</p>' +
                '                    </div>' +
                '                </div>';
        }
        $chtml += '' +
            '            </div>' +
            '            <div class="row border-top mt-3">' +
            '                <div class="col-sm-12">';
        if($review && $review.answer) {
            $chtml += '' +
                '<div class="result-info-count pt-3">' +
                '    Response:' +
                //'    Response from' +
                //'    <span class="link-color font-weight-bold open-url" data-url="'+$review.answer.user.profile_url+'">' +
                //$review.answer.user.long_name +
                //'    </span>' +
                '</div>';
        }
        $chtml+='' +
            '                    <div class="mt-2 font-weight-normal">' +
            '                        <div class="form-group">' +
            '                            <textarea class="form-control" name="answer" placeholder="Type Response Here...">';
        if($review && $review.answer && $review.answer.answer){
            $chtml+=$review.answer.answer;
        }
        $chtml+='</textarea>' +
            '                        </div>' +
            '                    </div>' +
            '                </div>' +
            '            </div>' +
            '        </div>' +
            '    </div>' +
            '    <div class="col-sm-12 text-right py-3">' +
            '        <button type="button" class="btn btn-save btnAnimate mb-2 option" data-action="delete review">Delete Review</button>' +
            '        <button type="button" class="btn btn-save btnAnimate mb-2 option" data-action="delete answer">Delete Owner Response</button>' +
            '        <button type="button" class="btn btn-save btnAnimate mb-2 option" data-action="save">Save</button>' +
            '    </div>' +
            '</div>';

        return $chtml;
    },
    reviews_popup_events:function($params, $data, cback){
        var $modal = $("#nurseslounge-lounge-review-answer-modal");
        var $answer = $modal.find('textarea[name="answer"]');
        $modal.find('.option').unbind().click(function(){
            var $that = $(this);
            var $action = $that.data('action');
            $params = $.extend({},$params, {action:$action,answer:$answer.val()});
            nurseslounge_lounge_ratingReviews.review_answer_set($params, function($data) {
                switch($action){
                    case 'delete review':
                        libs.refreshBoxFrom('.review-box', $params, function () {
                            nurseslounge_lounge_ratingReviews.init($params, function(){
                                $modal.modal('hide');
                            });
                        });
                        break;
                    case 'delete answer':
                        nurseslounge_lounge_ratingReviews.init($params, function(){
                            $modal.modal('hide');
                        });
                        break;
                    case 'save':
                        nurseslounge_lounge_ratingReviews.init($params, function(){
                            $modal.modal('hide');
                        });
                        break;
                }
            });
        });
        $modal.find('.open-url').unbind().click(function(){
            var $url = $(this).data('url');
            window.open($url,'_blank');
        });
        if(cback != undefined){
            cback();
        }
    },
    review_answer_set:function($params, cback){
        $.ajax({
            url: "/lounge/review/answer/set",
            method: "POST",
            cache:false,
            dataType: "json",
            data:$params,
            success: function ($data) {
                libs.expire($data);
                nurseslounge_lounge_ratingReviews.task_list_container(function($container){
                    $params = $.extend({}, $params, {only:'owners'});
                    nurseslounge_myDashboard_myProfile.task_list($container, $params);
                });
                if($data.status == 'error'){
                    $("#nurseslounge-lounge-information-review-modal").modal('hide');
                    $("#nurseslounge-lounge-review-answer-modal").modal('hide');
                }
                cback($data);
            }
        });
    },
    //Banners
    banners_location:function(cback){
        cback({
            'banners':$("#nurseslounge-lounge-reviews .nurseslounge-lounge-reviews-right .banners")
        });
    },
    lounge_ads_location:function(cback){
        cback({
            'ads':$("#nurseslounge-lounge-reviews .nurseslounge-lounge-reviews-right .lounge-ads")
        });
    },
    //Task List Container
    task_list_container:function(cback){
        var $container = $("#nurseslounge-lounge-reviews .nurseslounge-lounge-reviews-right");
        cback($container);
    },
    //Report
    report_container:function(cback){
        var $container = $("#nurseslounge-lounge-reviews .nurseslounge-lounge-reviews-right .report");
        cback($container);
    },
};
